module.exports = __webpack_public_path__ + "img/urine_toxicology_screening.fc640832.svg";